<template>
  <v-avatar color="secondary" size="50" class="logo-avatar">
    <template v-if="type === 'mdi'">
      <v-icon color="white">{{ icon }}</v-icon>
    </template>
    <template v-else-if="type === 'svg'">
      <img :src="icon" alt="Logo" class="logo-svg" />
    </template>
  </v-avatar>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    icon: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      default: 'mdi'
    }
  }
};
</script>

<style scoped>
.logo-avatar {
  color: white;
}

.logo-svg {
  width: 50%;
  height: 50%;
  object-fit: contain;
  filter: invert(100%);
}
</style>
